import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import { Typography } from '@material-ui/core';
import RoundButton from 'Components/UI/RoundButton';

const styles = theme => ({
  root: {
    display: 'flex',
    marginBottom: theme.spacing(3),
  },
  text: {
    flexGrow: 1,
    maxWidth: theme.dimensions.md,
  },
  title: {
    color: theme.palette.facet.accentBlue,
    fontSize: theme.typography.h1.fontSize,
    fontWeight: theme.typography.fontWeightBold,
    lineHeight: 1,
  },
  subtitle: {
    color: theme.palette.primary.main,
    ...theme.typography.h4,
  },
  meetingTitle: {
    color: theme.palette.facet.darkGray,
  },
  zoomButton: {
    minWidth: theme.dimensions.xs,
    maxHeight: 32,
    alignSelf: 'flex-end',
    marginLeft: 'auto',
    color: theme.palette.common.white,
    fontWeight: theme.typography.fontWeightBold,
    flexShrink: 1,
  },
});

const AgendaHeader = ({ className, classes, meetingResource }) => {
  const { householdResource } = useSimpleHousehold();
  const fullName = `${householdResource?.attr('primaryClientFirstName')} ${householdResource?.attr('primaryClientLastName')}`;

  const link = meetingResource.attr('link');
  const linkDisabled = link.length === 0;
  const meetingTitle = `${moment(
    meetingResource?.attr('startTime'),
  ).format('M/D/YY, h:mmA')} ${moment.tz
    .zone(moment.tz.guess())
    .abbr(Date.now())} - ${meetingResource?.attr('title')}`;

  return (
    <div className={classNames(classes.root, className)}>
      <div className={classes.text}>
        <Typography className={classNames(classes.title)}>
          Client
        </Typography>
        <Typography noWrap className={classNames(classes.subtitle)}>
          {fullName}
        </Typography>
        <Typography noWrap variant="body1" className={classNames(classes.meetingTitle)}>
          {meetingTitle}
        </Typography>
      </div>
      <RoundButton
        noWrap
        color="secondary"
        component="a"
        className={classes.zoomButton}
        disabled={linkDisabled}
        disableElevation
        href={link}
        target="_blank"
        variant="contained"
      >
        {linkDisabled ? 'Zoom Link Not Found' : 'Launch Zoom'}
      </RoundButton>
    </div>
  );
};

AgendaHeader.defaultProps = {
  className: '',
};

AgendaHeader.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  meetingResource: PropTypes.object.isRequired,
};

export default withStyles(styles)(AgendaHeader);
